<template>
  <article style="height: 100%">
    <children-wrapper></children-wrapper>

    <div ref="header">
      <search-input
        placeholder-word="搜索"
        @on-focus="handleFocus"
        v-if="currOperation !== 'search'">
      </search-input>
      <tab-list
        :tab-list="tabList"
        :status.sync="queryForm.status"
        @tab-change="tabChange"
        v-if="currOperation !== 'search'">
      </tab-list>
    </div>

    <!-- height要算准确 -->
    <scroller
      lock-x scrollbar-y
      use-pullup
      :height="scrollerHeight"
      @on-pullup-loading="loadMore"
      :pullup-config="pullConfig"
      v-if="totalCount">
      <div :class="{'mt-20': currOperation !== 'search'}">
        <group v-for="(item, index) in dataList" :key="index" class="auction-manage auction_info_group">
          <cell class="v-title" v-if="currOperation === 'search'">
            <div slot="icon">
              <span v-if="item.status">
                <template v-if="item.status === 1">询价中</template>
                <template v-if="item.status === 2">已询价</template>
              </span>
              <span v-else-if="item.is_finished">
                已询价<span v-text="getEnquiryType(item.enquiry_type)"></span>
              </span>
              <span v-else>
                询价中<span v-text="getEnquiryType(item.enquiry_type)"></span>
              </span>
            </div>
          </cell>
          <cell class="auction_info" :bdStart="true">
            <img slot="icon" class="auction_img" :src="item.car_image">
            <div slot="after-title" class="auction_content">
              <p>{{item.car_model_name}}</p>
              <p class="price">预计结束：{{item.finished_at}}</p>
              <p class="price">最高报价：<span style="color: #fb3f3f;">{{item.maximum_quote_price | formatePrice}}</span></p>
              <p class="price">车架号：{{item.vin}}</p>
              <p class="price">车牌号：{{item.plate_number}}</p>
            </div>
          </cell>
          <cell class="fs0 used-btn">
            <div slot="value" class="operate_btn">
              <x-button mini plain type="primary" @click="getDetail(item)" v-text="getDetailBtnName(item)"></x-button>
              <x-button mini plain type="primary" v-if="seeEnquiryAuth" @click="getInfo(item)">询价信息</x-button>
            </div>
          </cell>
        </group>
        <p class="tip-text1">共{{totalCount}}条记录</p>
      </div>
    </scroller>
    <no-car :title="noCarTitle" v-else></no-car>
  </article>
</template>
<script>
import {
  XButton,
  Scroller,
  Cell,
  Group
} from '@lx-frontend/cvux'
import SearchInput from '../components/SearchInput'
import ChildrenWrapper from '../components/ChildrenWrapper'
import TabList from '../components/TabList'
import NoCar from '../components/NoCar'
import util from '../../common/util'
import routerMixin from '../../mixins/router.js'

export default {
  mixins: [routerMixin],
  components: {
    TabList,
    NoCar,
    XButton,
    Scroller,
    Cell,
    Group,
    SearchInput,
    ChildrenWrapper
  },
  data() {
    return {
      pullConfig: {
        content: '',
        downContent: '',
        upContent: '',
        loadingContent: '加载中...'
      },
      tabList: [
        { key: 1, name: '询价中' },
        { key: 2, name: '已询价' }
      ],
      fromApi: {
        inquiry: 'used_car/ticket/enquiries',
        auction: 'auctions/auction_car_enquiries'
      },
      titleList: {
        inquiry: '线索询价',
        auction: '车辆询价管理',
        search: '搜索结果'
      },
      source: '',
      urlLeft: '',
      totalCount: 0,
      totalPage: 0,
      queryForm: {
        status: 1,
        count: 10,
        page: 1
      },
      dataList: [],
      currOperation: '', // 页面当前的操作，search为搜索结果页
      scrollerHeight: '', // scroller组件的高度
      title: {
        list: '暂无车辆',
        search: '未查询到相关信息'
      },
      noCarTitle: '',
      seeEnquiryAuth: false // 询价信息按钮权限
    }
  },
  filters: {
    formatePrice(price) {
      return price ? `${(price / 1000000).toFixed(2)}万元` : '--'
    }
  },
  created() {
    this.noCarTitle = this.title.list
    if (this.$cacheRoute.query.operation === 'search') {
      this.noCarTitle = this.title.search
      this.currOperation = this.$cacheRoute.query.operation
    }
    this.source = this.$cacheRoute.params.inquirySource

    // 处理不同入口询价信息权限
    const authConfig = {
      'inquiry': 'used_car_ticket.enquiry.view',
      'auction': 'used_car_car.enquiry.view',
      'inquirys': 'used_car_ticket.enquiry.view'
    }
    this.$store.state.promiseAuth.then(auth => {
      this.seeEnquiryAuth = auth.authList.includes(authConfig[this.source])
    })
  },
  mounted() {
    this.judgeScrollerHright()
    this.urlLeft = this.fromApi[this.source]
    this.queryForm.status = +this.$store.state.selectStatus
    util.changeTitle(this.titleList[this.currOperation ? 'search' : this.source])
    this.getData()
  },
  methods: {
    // 详情按钮文本
    getDetailBtnName(item) {
      let res = ''
      switch (this.source) {
        case 'inquiry':
          res = '线索询价'
          break
        case 'auction':
          res = '车辆询价'
          break
        case 'inquirys': // 包含线索和车辆询价
          if (item.enquiry_type === 1) {
            res = '线索详情'
          } else if (item.enquiry_type === 2) {
            res = '车辆详情'
          }
          break
      }
      return res
    },
    // 询价类型
    getEnquiryType(type) {
      let res = ''
      if (type) {
        if (type === 1) {
          res = '（线索询价）'
        } else if (type === 2) {
          res = '（车辆询价）'
        }
      }
      return res
    },
    // 切换tab
    tabChange() {
      this.queryForm.page = 1
      this.totalCount = 0
      this.dataList = []
      this.getData()
    },
    getDetail(item) {
      switch (this.source) {
        case 'inquiry': // 线索询价
          this.$router.push({ path: `${this.$cacheRoute.path}/evaluateReport/${item.car_info_id}/inquiry`, query: { default: 1 } })
          break
        case 'auction': // 车辆询价
          this.$router.push({ path: `${this.$cacheRoute.path}/evaluateReport/${item.car_info_id}/auction`, query: { default: 1 } })
          break
        case 'inquirys':
          if (item.enquiry_type === 1) { // 线索详情
            // this.$router.push({ path: `${this.$cacheRoute.path}/detail/${item.ticket_id}` })
            this.$router.push({ path: `${this.$cacheRoute.path}/evaluateReport/${item.car_info_id}/inquiry`, query: { default: 1 } })
          } else if (item.enquiry_type === 2) { // 车辆详情
            this.$router.push({ path: `${this.$cacheRoute.path}/evaluateReport/${item.car_info_id}/auction`, query: { default: 1 } })
          }
          break
      }
    },
    getInfo(v) {
      this.$store.commit('UPDATE_SELECTSTATUS', this.queryForm.status)
      if (v.ticket_id) { // 线索询价
        this.$rest.usedCar.getTicket(null, `${v.ticket_id}/operations`).then(res => {
          if (res.code === 0) {
            // 获取二手车线索支持的操作
            let isSupport = res.data.operations.is_support_enquiry ? 1 : 0
            this.$router.push({
              path: `${this.$cacheRoute.path}/inquiryInfo/${v.enquiry_id}/inquiry`,
              query: { need_btn: isSupport, match: true }
            })
          } else {
            this.showToast(res.message)
          }
        })
      } else { // 车辆询价
        this.$router.push({ path: `${this.$cacheRoute.path}/inquiryInfo/${v.enquiry_id}/auction`, query: { match: true } })
      }
    },
    /**
     * @description 判断列表数据请求的参数
     */
    judgeRequestData() {
      let params = {
        page: this.queryForm.page,
        count: this.queryForm.count
      }
      if (this.$cacheRoute.query.operation === 'search') {
        params[this.$cacheRoute.query.searchType] = this.$cacheRoute.query.value
      } else {
        params.status = this.queryForm.status
      }
      return { params: params }
    },
    getData() {
      this.switchLoading({ status: true, text: '加载中...' })
      this.getRequestResult().then(res => {
        if (res.code === 0) {
          this.handleInquiryListData(res.data)
        } else {
          this.showToast(res.message)
        }
        this.switchLoading({ status: false })
      })
    },
    // 匹配不同请求接口
    getRequestResult() {
      let requestData = this.judgeRequestData()
      // searchType值是auction_car_id，则调用包含车辆询价和线索询价的 车辆询价列表接口
      if (requestData.params.auction_car_id) {
        return this.$rest.inquiry.getCarClueEnquiry(requestData.params, `${requestData.params.auction_car_id}/enquiries`)
      }
      return this.$rest.inquiry.getCarList(requestData.params, this.urlLeft)
    },
    loadMore(done) {
      if (this.queryForm.page < this.totalPage) {
        ++this.queryForm.page
        this.getRequestResult().then(res => {
          if (res.code === 0) {
            this.handleInquiryListData(res.data)
            done(100)
          } else {
            this.showToast(res.message)
          }
        })
      } else {
        done()
      }
    },
    handleInquiryListData(data) {
      if (data) {
        let count = this.queryForm.count
        this.totalCount = data.total_count
        this.totalPage = parseInt((this.totalCount + count - 1) / count)
        this.dataList = this.dataList.concat(data.enquiries)
      }
    },
    handleFocus() {
      document.activeElement.blur()
      if (this.source === 'inquiry') {
        this.$router.push(`/usedCar/search/${'inquiry'}`)
      } else if (this.source === 'auction') {
        this.$router.push(`/usedCar/search/${'inquiryList'}`)
      }
    },
    judgeScrollerHright() {
      if (this.currOperation === 'search') {
        this.scrollerHeight = '100%'
      } else {
        this.scrollerHeight = `-${this.$refs.header.offsetHeight}px`
      }
    }
  }
}

</script>
<style scoped lang="less">
  @import "../../stylesheets/modules/manage/index.less";
  @import '../../stylesheets/base/fn';
 .auction_info_group {
  .auction_info {
    padding: 30/@w2;
    .auction_img {
      display: block;
      width: 200/@w2;
      height: 133/@w2;
    }
    .auction_content {
      p {
        line-height: 40/@w2;
        margin-bottom: 15/@w2;
      }
      .price {
        line-height: 1;
        font-size: 26/@w2;
        color: #666;
      }
    }
  }
  .operate_btn {
    .weui_btn {
      margin-left: 15/@w2;
      font-size: 26/@w2;
      .radius(4/@w2);
    }
  }
}
.mar-top{
  margin-top: 20/@w2;
}

</style>
